import classNames from 'classnames';
import {useMediaQuery} from 'hooks/useMediaQuery';
import {breakpoints} from 'lib/breakpoints';
import {FC} from 'react';

import {ReactComponentIcon} from 'components/ReactComponentIcon/ReactComponentIcon';
import {Text} from 'components/Text/Text';

import styles from './CartAuthNotificationBanner.module.css';
import {ReactComponent as LoaderIcon} from './loader.svg';

type Props = {
    className?: string;
};
export const CartAuthNotificationBanner: FC<Props> = ({className}) => {
    const isDesktop = useMediaQuery(breakpoints.up('sm'));
    const TitleComponent = isDesktop ? Text.Bold24 : Text.Bold20;

    return (
        <div className={classNames(styles.block, className)}>
            <div className={styles.info}>
                <ReactComponentIcon icon={LoaderIcon} className={styles.icon} />
                <TitleComponent className={styles.title}>
                    Ура, личный кабинет сформирован!
                </TitleComponent>
                <Text.Semibold14 className={styles.description}>
                    Мы должны проверить ваши данные. После этого вам будут
                    доступны все функции личного кабинета. Обычно проверка
                    занимает несколько часов. Мы вышлем вам sms-уведомление,
                    когда все будет готово.
                </Text.Semibold14>
                <Text.Bold16 className={styles.statusText}>
                    А пока вы можете завершить оформление своего заказа
                </Text.Bold16>
            </div>
        </div>
    );
};
